"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.settings.chunkSize.label': 'Tamaño de Fragmento',
    'rag.settings.chunkSize.description': 'Tamaño de fragmentos de texto para indexación (100-2000 caracteres)',
    'rag.settings.chunkOverlap.label': 'Superposición de Fragmentos',
    'rag.settings.chunkOverlap.description': 'Superposición entre fragmentos para preservar contexto (0-500 caracteres)',
    'rag.settings.similarityThreshold.label': 'Umbral de Similitud',
    'rag.settings.similarityThreshold.description': 'Puntuación mínima de similitud para resultados de búsqueda (0.1-1.0)',
    'rag.settings.defaultMaxResults.label': 'Resultados Máx. Predeterminados',
    'rag.settings.defaultMaxResults.description': 'Número predeterminado de resultados de búsqueda a devolver (1-20)',
    'rag.settings.maxResults.label': 'Resultados Máximos',
    'rag.settings.maxResults.description': 'Número máximo de resultados de búsqueda permitidos (1-20)',
    'rag.settings.separators.label': 'Separadores de Texto',
    'rag.settings.separators.description': 'Caracteres usados para dividir texto en fragmentos (separados por comas)',
    'rag.settings.separators.placeholder': 'Ingrese separadores separados por comas',
    'rag.settings.separators.add': 'Agregar Separador',
    'rag.settings.resetToDefaults.label': 'Restablecer Valores Predeterminados',
    'rag.settings.resetToDefaults.tooltip': 'Restablecer configuración RAG a valores predeterminados',
};
